import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './styles/home.css';
import phonePNG from '../assets/img/phone.png';
import passwdPNG from '../assets/img/passwd.png';
import namePNG from '../assets/img/name.png';
import { registration } from "../action/user";
import { getFilials } from "../action/filial"; // Импортируем getFilials для получения списка филиалов
import { getSettings } from "../action/settings"; // Импортируем getSettings для получения настроек
import axios from "axios";
import { useDispatch } from 'react-redux';
import config from "../config";
import { pushNotificationUtil } from "../utils/pushNotificationUtil";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import PublicFooter from "./PublicFooter";

const Registration = () => {
    const { t } = useTranslation();
    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [username, setUsername] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [selectedFilial, setSelectedFilial] = useState(""); // Добавляем состояние для выбранного филиала
    const [filials, setFilials] = useState([]); // Состояние для списка филиалов
    const [referrerPhone, setReferrerPhone] = useState(''); // номер пригласившего клиента (реферальная программа)
    const [isChecked, setIsChecked] = useState(false);
    const [requireInvite, setRequireInvite] = useState(false); // регистрация только по коду от представителя филиала
    const [contractFilePath, setContractFilePath] = useState(""); // Состояние для пути к файлу
    const [invited, setInvited] = useState({ phone: false, code: false, filial: '' }); // что пришло по ссылке-приглашению от представителя филиала


    const navigate  = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        // Проверяем наличие реферального параметра в URL
        const searchParams = new URLSearchParams(location.search);
        const ref = searchParams.get('ref');
        if (ref) {
            setReferrerPhone(String(ref).replace(/\D/g, ''));
        }
        // Ссылка-приглашение (/registration?phone=…&code=…&name=…&f=…): номер, код, имя и филиал уже подставлены.
        // Без параметров форма работает как раньше, поэтому ранее отправленные приглашения не ломаются.
        const invPhone = String(searchParams.get('phone') || '').replace(/\D/g, '').slice(0, 15);
        const invCode = String(searchParams.get('code') || '').replace(/[^A-Za-z0-9_.-]/g, '').slice(0, 30);
        const invName = String(searchParams.get('name') || '').replace(/\s+/g, ' ').trim().slice(0, 60);
        const invFilial = String(searchParams.get('f') || '').slice(0, 80);
        if (invPhone) setPhone(invPhone);
        if (invCode) setUsername(invCode);
        if (invName) setName(invName);
        if (invPhone || invCode || invFilial) setInvited({ phone: Boolean(invPhone), code: Boolean(invCode), filial: invFilial });
        
        // Загружаем список филиалов при загрузке компонента
        const fetchFilials = async () => {
            const allFilials = await getFilials();
            setFilials(Array.isArray(allFilials) ? allFilials : []); // при ошибке загрузки страница не должна падать
        };

        // Загружаем настройки, включая путь к файлу контракта
        const fetchSettings = async () => {
            const settings = await getSettings();
            if (settings && settings.contractFilePath) {
                setContractFilePath(settings.contractFilePath);
            }
        };

        fetchSettings();
        fetchFilials();
        axios.get(`${config.apiUrl}/api/auth/registration-mode`)
            .then((res) => setRequireInvite(Boolean(res.data && res.data.requireInvite)))
            .catch(() => setRequireInvite(false));
    }, [location]);

    const handleRegistration = async () => {
        const registrationSuccess = await dispatch(registration(name, surname, phone, password, referrerPhone, selectedFilial, isChecked, username));
        if (registrationSuccess) {
            // Инициализируем push-уведомления после успешной регистрации
            if (pushNotificationUtil.isSupported()) {
                const hasPermission = await pushNotificationUtil.requestPermission();
                if (hasPermission) {
                    await pushNotificationUtil.registerServiceWorker();
                }
            }
            navigate("/main");
        }
    };

    
    return (
      <div className="auth-page">
      <div className="auth">
        <div className="form">
            <LanguageSwitcher compact />
            <h1 className="h1-auth">{t('auth.regTitle')}</h1>
            {invited.filial && <p className="invite-notice">{t('auth.invitedBranch', { name: invited.filial })}</p>}
            {requireInvite && !(invited.phone && invited.code) && <p className="invite-notice">{t('auth.inviteNotice')}</p>}
            <div className="input__div"><img src={namePNG} alt="person" className="phonePNG"/>
                <input value={name} onChange={(event) => setName(event.target.value)} type="text" className="input" placeholder={t('auth.name')}/>
            </div>
            <div className="input__div"><img src={namePNG} alt="person" className="phonePNG"/>
                <input value={surname} onChange={(event) => setSurname(event.target.value)} type="text" className="input" placeholder={t('auth.surname')}/>
            </div>
            <div className="input__div"><img src={namePNG} alt="username" className="phonePNG"/>
                <input value={username} onChange={(event) => setUsername(event.target.value)} type="text" className="input" placeholder={t('auth.usernamePh')} autoCapitalize="none" autoCorrect="off" maxLength={30} readOnly={invited.code}/>
            </div>
            <p className="code-hint">{t('auth.codeHint')}</p>
            <div className="input__div"><img src={phonePNG} alt="Phone" className="phonePNG"/>
                <input value={phone} onChange={(event) => setPhone(event.target.value)} type="number" className="input" placeholder="8XXXXXXXXXX" readOnly={invited.phone}/>
            </div>
            <div className="input__div"><img src={phonePNG} alt="" className="phonePNG"/>
                <input value={referrerPhone} onChange={(event) => setReferrerPhone(event.target.value)} type="tel" inputMode="numeric" className="input" placeholder={t('auth.referrerPh')}/>
            </div>
            {!requireInvite && (
            <div className="input__div">
                <select value={selectedFilial} onChange={(e) => setSelectedFilial(e.target.value)} className="input">
                    <option value="">{t('auth.chooseBranch')}</option>
                    {filials.map(filial => (
                        <option key={filial.filial._id} value={filial.filial.filialText}>
                            {filial.filial.filialText} {/* Теперь сохраняем не ID, а название */}
                        </option>
                    ))}
                </select>
            </div>
            )}
            <div className="input__div"><img src={passwdPNG} alt="Password" className="phonePNG"/>
                <input value={password} onChange={(event) => setPassword(event.target.value)} type="password" className="input" placeholder={t('auth.passwordPh')}/>
            </div>
            
            {/* Выпадающий список для выбора филиала */}
           
            <div className="checkbox__div">
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(event) => setIsChecked(event.target.checked)}
                />
                <span className="checkbox__text">
                {t('auth.agree')} {contractFilePath && (
                            <a href={`${config.apiUrl}${contractFilePath}`} target="_blank" rel="noopener noreferrer" className="terms-link">
                                {t('auth.terms')}
                            </a>
                        )}
                </span>
            </div>

            <button className="buttonLogin" onClick={handleRegistration}>{t('auth.register')}</button>
            <Link to="/login" className="link__auth">{t('auth.login')}</Link>
        </div>
      </div>
      <PublicFooter />
      </div>
    );
}

export default Registration;
